import React from "react";

import SectionShapes from "./section-shapes";
import { SectionTitle } from "./section-title";
import { type ShapeItem } from "./shape-item.types";

interface SelectedAreaProps {
  shapes: ShapeItem[];
}

export const SelectedArea: React.FC<SelectedAreaProps> = ({
  shapes,
}) => {
  return (
    <div>
      <SectionTitle title="Selected Area" />

      <SectionShapes shapes={shapes} />
    </div>
  );
};
